import { Panel } from '@vkontakte/vkui';
import type { ReactNode } from 'react';
import { BackButton } from './BackButton';
import { ScreenHeader } from './ScreenHeader';
import { ScreenTitle } from './ScreenTitle';
import styles from './ui.module.css';

/**
 * Экран приложения: каркас панели, шапка и то, что у всех экранов одинаково.
 *
 * Панель остаётся вкуишной — за ней safe-area, шапка и поведение `View`. Своё
 * здесь то, что раньше приходилось помнить на каждом экране:
 *
 * — `disableBackground`: фон страницы у Мезы градиентный, и панель не должна
 *   заливать его своей плоской краской;
 * — хвост внизу: под таббаром обязано оставаться место, иначе последняя
 *   строка прилипает к нему вплотную. Пока его не было, это чинилось по
 *   одному экрану за раз;
 * — САМА ШАПКА. Экран называет заголовок, возврат и счёт, а не собирает
 *   `ScreenHeader` с `BackButton` и `ScreenTitle` внутри заново. Пока сборку
 *   писал каждый, одна правка возврата стоила восемнадцати файлов.
 *
 * Без `title` шапки нет вовсе — так у карточки персонажа, где возврат лежит
 * на кадре, а имя набрано поверх фотографии.
 */
export function Screen({
  id,
  title,
  back,
  count,
  unit,
  number,
  loud,
  after,
  children,
}: {
  id: string | undefined;
  /** Название экрана. Нет названия — нет и шапки. */
  title?: string;
  /**
   * Что делает возврат. Обычно это `useBack()` из `app/`, но экран волен
   * отдать своё: редактор анкеты сначала спрашивает про несохранённое,
   * админка закрывает открытую карточку. Хук зовёт сам экран, а не шапка:
   * `shared/ui` про маршруты приложения не знает и знать не должен.
   */
  back?: () => void;
  /** Счёт списка в правом краю шапки. Остальное — как у `ScreenTitle`. */
  count?: number | null;
  unit?: string;
  number?: number | null;
  loud?: boolean;
  after?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Panel id={id} disableBackground>
      {title === undefined ? null : (
        <ScreenHeader before={back === undefined ? undefined : <BackButton onClick={back} />}>
          <ScreenTitle count={count} unit={unit} number={number} loud={loud} after={after}>
            {title}
          </ScreenTitle>
        </ScreenHeader>
      )}
      {children}
      <div className={styles.screenTail} />
    </Panel>
  );
}
